export type ContentArtifactCardType =
  | "post"
  | "digital_ad"
  | "email_html"
  | "email_plaintext"
  | "ig_comment_reply";

export const getContentArtifactCardType = (
  artifactType?: string | null,
): ContentArtifactCardType | null => {
  switch (artifactType) {
    case "instagram_post":
    case "post":
      return "post";
    case "digital_ad":
      return "digital_ad";
    case "email_plaintext":
      return "email_plaintext";
    case "email_html":
    case "email_with_variants":
    case "email":
      return "email_html";
    case "instagram_comment_reply":
    case "ig_comment_reply":
      return "ig_comment_reply";
    default:
      return null;
  }
};
